<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MultiSelect from 'dashboard/components-next/filter/inputs/MultiSelect.vue';

const props = defineProps({
  teams: {
    type: Array,
    default: () => [],
  },
  isAdmin: {
    type: Boolean,
    default: false,
  },
  myTeamIds: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();

const visibility = defineModel('visibility', {
  type: String,
  default: 'global',
});

const teamIds = defineModel('teamIds', {
  type: Array,
  default: () => [],
});

const options = [
  {
    value: 'global',
    label: t('CANNED_MGMT.VISIBILITY.GLOBAL.LABEL'),
    description: t('CANNED_MGMT.VISIBILITY.GLOBAL.DESCRIPTION'),
  },
  {
    value: 'personal',
    label: t('CANNED_MGMT.VISIBILITY.PERSONAL.LABEL'),
    description: t('CANNED_MGMT.VISIBILITY.PERSONAL.DESCRIPTION'),
  },
  {
    value: 'team',
    label: t('CANNED_MGMT.VISIBILITY.TEAM.LABEL'),
    description: t('CANNED_MGMT.VISIBILITY.TEAM.DESCRIPTION'),
  },
];

const teamOptions = computed(() => {
  const selectable = props.isAdmin
    ? props.teams
    : props.teams.filter(team => props.myTeamIds.includes(Number(team.id)));
  return selectable.map(team => ({ id: team.id, name: team.name }));
});

const selectedTeams = computed({
  get() {
    return teamOptions.value.filter(team => teamIds.value.includes(team.id));
  },
  set(value) {
    teamIds.value = value.map(team => team.id);
  },
});
</script>

<template>
  <div class="flex flex-col w-full gap-2">
    <label>{{ $t('CANNED_MGMT.VISIBILITY.LABEL') }}</label>
    <div class="flex flex-col gap-2">
      <label
        v-for="option in options"
        :key="option.value"
        class="flex items-start gap-2 cursor-pointer"
      >
        <input
          v-model="visibility"
          type="radio"
          name="canned-response-visibility"
          :value="option.value"
          class="mt-1"
        />
        <span class="flex flex-col">
          <span class="text-n-slate-12">{{ option.label }}</span>
          <span class="text-body-main text-n-slate-11">
            {{ option.description }}
          </span>
        </span>
      </label>
    </div>

    <div v-if="visibility === 'team'" class="flex flex-col gap-1 mt-1">
      <label>{{ $t('CANNED_MGMT.VISIBILITY.TEAM_SELECT.LABEL') }}</label>
      <MultiSelect v-model="selectedTeams" :options="teamOptions" />
    </div>
  </div>
</template>
